import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { EdgeCache } from "@/lib/lazyPages";

interface EdgeCacheSearch {
  path?: string;
  host?: string;
  outcome?: string;
  reason?: string;
}

export const Route = createFileRoute("/admin/edge-cache")({
  validateSearch: (search: Record<string, unknown>): EdgeCacheSearch => {
    const pick = (key: keyof EdgeCacheSearch) =>
      typeof search[key] === "string" && search[key] ? (search[key] as string) : undefined;
    const out: EdgeCacheSearch = {};
    for (const key of ["path", "host", "outcome", "reason"] as const) {
      const value = pick(key);
      if (value) out[key] = value;
    }
    return out;
  },

  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <EdgeCache />
    </RouteGuard>
  ),
});
